"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
const errors_1 = require("@seneca/errors");
class TutorResourcesServiceClient extends client_library_1.Client {
    constructor(fetch, options) {
        super(fetch, options);
    }
    /*
      @deprecated
      - Does not include quiz resources, aggregations or rank_features
      - Needed for existing consumers that do not expect quiz resources
      - Use queryResourcesV2 instead
    */
    async queryResources({ query, filters, sort, from, size }) {
        const url = `${this.url}/api/query-resources`;
        const options = {
            method: 'POST',
            body: JSON.stringify({ query, filters, sort, from, size })
        };
        const expectedResponses = [200, 422];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 422) {
            const body = response.json;
            throw new errors_1.InvalidArgumentError(body.pointer, body.reason);
        }
        return response.json;
    }
    async querySchoolResources({ schoolId, query, filters, excludedFilters, sort, from, size, aggregationCategoryIds }) {
        const url = `${this.url}/api/query-resources/schools/${schoolId}`;
        const options = {
            method: 'POST',
            body: JSON.stringify({
                schoolId,
                query,
                filters,
                excludedFilters,
                sort,
                from,
                size,
                aggregationCategoryIds
            })
        };
        const expectedResponses = [200, 403, 422];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 403) {
            throw new Error('User not permitted to access school resources');
        }
        if (response.status === 422) {
            const body = response.json;
            throw new errors_1.InvalidArgumentError(body.pointer, body.reason);
        }
        return response.json;
    }
    async queryResourcesV2({ query, filters, sort, from, size, aggregationCategoryIds }) {
        const url = `${this.url}/api/v2/query-resources`;
        const options = {
            method: 'POST',
            body: JSON.stringify({
                query,
                filters,
                sort,
                from,
                size,
                aggregationCategoryIds
            })
        };
        const expectedResponses = [200, 422];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 422) {
            const body = response.json;
            throw new errors_1.InvalidArgumentError(body.pointer, body.reason);
        }
        return response.json;
    }
    async fetchResource(id) {
        const url = `${this.url}/api/resources/${id}`;
        const options = {
            method: 'GET'
        };
        const expectedResponses = [200, 400, 404];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 400) {
            const body = response.json;
            throw new errors_1.InvalidArgumentError(body.pointer, body.reason);
        }
        if (response.status === 404) {
            return null;
        }
        return response.json;
    }
    async addNewResource({ title, contentUrl, tags, email }) {
        const url = `${this.url}/api/add-resource`;
        const options = {
            method: 'POST',
            body: JSON.stringify({ title, contentUrl, tags, email })
        };
        const expectedResponses = [200, 422];
        const response = await this.requestMaker.makeRequest(url, options, expectedResponses);
        if (response.status === 422) {
            const body = response.json;
            throw new errors_1.InvalidArgumentError(body.pointer, body.reason);
        }
    }
}
exports.default = TutorResourcesServiceClient;
//# sourceMappingURL=TutorResourcesServiceClient.js.map